import React, { Component } from "react";
import LogNav from "../layout/LoggedNav";
import { getAuthData } from "../../services/authService";
import ENUMS from "../../utils/ENUMS.js";
import axios from "axios";
import { NavLink } from "react-router-dom";
import moment from "moment";
import { BASE_URL } from "../../config.json";
import CustomLoader from "../Reusable/CustomLoader";
import { toast, ToastContainer } from "react-toastify";

import { getCourseList } from "../layout/live-view/live.view.api.services.js";
const auth = getAuthData();
const token = localStorage.getItem(ENUMS.AUTH);
let array_push = [];
let new_push = [];
const role = localStorage.getItem("userRole") || "";
const isSuperAdmin = role.toLowerCase() === "superadmin";

export default class AccHome extends Component {
  constructor(props) {
    super(props);
    this.state = { dataRes: [], new: [], loading: false };
  }
componentDidMount() {
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  this.setState({ loading: true });

  Promise.all([getCourseList(), axios.get(`${BASE_URL}/club/home/`, config)])
    .then(([courseRes, homeRes]) => {
      let courseList = [];
        console.log("coourse");
console.log("Course list API response:", courseRes);
        courseList = courseRes.data;

      if (
        courseRes.status === "SUCCESS" &&
        Array.isArray(courseRes.data) &&
        courseRes.data.length > 0
      ) {
         
        courseList = courseRes.data;
      }

      const homeData = homeRes.data?.data;
      array_push.push(homeData);
      new_push.push(homeData.course_live_data);

      this.setState({
        courseList,
        dataRes: [homeData],
        new: [homeData.course_live_data],
        loading: false,
      });
    })
    .catch((err) => {
      console.error("Error loading course/home data:", err);
        toast.error("Failed to load course or home data. Please try again.", {
      position: "top-right",
      autoClose: 4000,
      theme: "colored",
    });
    this.setState({ loading: false });
    });
}




  render() {
    return (
      <>
        <section className="section-p club_Login">
          <div className="page-width">
            <div className="acchome-block">
              <h1 className="cd-pass--title text-jost-sb-50">
                Welcome to {auth.club_name}
              </h1>
              <LogNav />
              <div className="acchome__wrap">
                <div className="acchome__box">
                  <div className="acchome__box__left">
                    {this.state.loading ? (
                      <CustomLoader
                        type={"spinner-cub"}
                        color={"#B4C227"}
                        size={100}
                      />
                    ) : (
                      this.state.dataRes.map((item, i) => {
                        const {
                          subscription_mapping,
                          annual_billing_end_date,
                          end_date,
                        } = item.club_membership;

                        const { status, start_date, subscription } =
                          subscription_mapping || {};

                        return (
                          <>
                            <h2 className="text-jost-sb-24">
                              Your Clubs Membership:
                            </h2>
                            <div
                              key={item.id}
                              className="acchome__box__left__info"
                            >
                              <div className="acchome__box__left__info-status">
                                <h2 className=" text-jost-sb-22">
                                  Account Status:
                                </h2>
                                <span className="text-jost-sb-22-lg ">
                                  {status?.label}
                                </span>
                              </div>
                              <div className="acchome__box__left__info-status">
                                <h2 className=" text-jost-sb-22">
                                  Account Renewal Date:
                                </h2>
                                <span className=" text-jost-sb-22">
                                  {moment(annual_billing_end_date).format(
                                    "DD/MM/YY"
                                  )}
                                </span>
                              </div>
                              <div className="acchome__box__left__info-status">
                                <h2 className=" text-jost-sb-22">
                                  Payment Frequency:
                                </h2>
                                <span className=" text-jost-sb-22">
                                  {subscription?.payment_frequency}
                                </span>
                              </div>
                              <div className="acchome__box__left__info-links">
                                <NavLink
                                  to="/billing"
                                  target="_self"
                                  className="res-btn-primary"
                                >
                                  View Billing
                                </NavLink>
                              </div>
                            </div>
                            <div className="acchome__box__left__ginfo">
                              <div className="acchome__box__left__ginfo-count">
                                <h2 className=" text-jost-sb-24">
                                  Current Members using the app:
                                </h2>
                                <span className=" text-jost-sb-22">
                                  {item.total_app_members}
                                </span>
                              </div>

                              {item.no_of_courses == 0 ? (
                                
                                <>
                                
                                  <div className="acchome__box__left__ginfo-count">
                                    <h2 className=" text-jost-sb-24">
                                      Number of Courses:{" "}
                                    </h2>
                                    <span className=" text-jost-sb-22">
                                      {item.no_of_courses}
                                    </span>
                                  </div>
                                  <div className="acchome__box__left__ginfo-count alert">
                                    <span className="text-ops-rg-18">
                                      It looks like you haven’t added any
                                      courses yet, please click below to add
                                      your courses
                                    </span>
                                    <NavLink
                                      to="/loged-user-courses"
                                      target="_self"
                                      className="res-btn-primary"
                                    >
                                      Go to courses
                                    </NavLink>
                                  </div>
                                </>
                              ) : (
                                <div className="acchome__box__left__ginfo-count">
                                  <h2 className=" text-jost-sb-24">
                                    Number of Courses:{" "}
                                  </h2>
                                  <span className=" text-jost-sb-22">
                                    {item.no_of_courses}
                                  </span>
                                  {/*<span>{item.no_of_courses}</span>*/}
                                </div>
                              )}

                              <div className="acchome__box__left__ginfo-count">
                                <h2 className=" text-jost-sb-24">
                                  Number of alerts sent to players today:{" "}
                                </h2>
                                <span className=" text-jost-sb-22">
                                  {item.alerts_sent_to_players_today}
                                </span>
                              </div>
                              <div className="acchome__box__left__ginfo-count">
                                <h2 className=" text-jost-sb-24">
                                  Number of Reported Incidents today:{" "}
                                </h2>
                                <span className=" text-jost-sb-22">
                                  {item.reported_incidents_today}
                                </span>
                              </div>
                              <div className="acchome__box__left__ginfo-links">
                                <NavLink
                                  to="/IncidentsLog"
                                  target="_self"
                                  className="res-btn-primary"
                                >
                                  View All Incidents
                                </NavLink>
                              </div>
                            </div>
                          </>
                        );
                      })
                    )}
                  </div>
                 {!isSuperAdmin && <div className="acchome__box__right">
                    {
                      (console.log(this.state.new.length, "LENGTH"),
                      this.state.new.map((data) => {
                        
                        console.log(data, "D");
                        return data.map((data1, index) => {
                          const course = this.state.courseList.data[index]; 
                          
                          console.log(course,"list");
                          
const courseId = course?.id;

                          return (
                            <>
                              <div className="card" key={data1.label}>
                                <div className="card__info">
                                  <h1 className="text-jost-sb-19-wt">
                                    {data1.label}
                                  </h1>
                                  <div className="card__info__date">
                                    <h1 className="text-jost-sb-19-wt">
                                      DATE:
                                    </h1>
                                    <span className="text-jost-sb-19-wt">
                                      {moment(data1.date).format("DD/MM/YY")}
                                    </span>
                                  </div>
                                  <h1 className="text-jost-sb-19-wt">
                                    People on course
                                  </h1>

                                  <div className="card__info__play">
                                    <h1 className="text-jost-sb-19-wt">
                                      Current live Players:
                                    </h1>
                                    <span className="text-jost-sb-19-wt">
                                      {data1.current_live_player}
                                    </span>
                                  </div>
                                  <div className="card__info__links">
                                    {data1.hole_coords_data
                                      .is_coords_partially_mapped ? (
                                      <NavLink
                                        to="/courses-live-view"
                                        target="_self"
                                        className="res-btn-primary"
                                         onClick={() =>
                                localStorage.setItem(
                                  "selectedLiveCourseId",
                                  courseId
                                )
                              }
                                      >
                                        Live View
                                      </NavLink>
                                    ) : (
                                      <NavLink
                                        to={{
                                          pathname: "/courses-map-courses",
                                          index: index,
                                        }}
                                        target="_self"
                                        className="res-btn-primary"
                                      >
                                        Map Course
                                      </NavLink>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </>
                          );
                        });
                      }))
                    }
                  </div>}
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}
